import React, { useEffect, createElement } from 'react';
export function Modulo0Page() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://player.vimeo.com/api/player.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e0e0e0] font-body" data-id="element-1474">
      {/* TOP NAV */}
      <nav className="sticky top-0 z-[100] flex h-[56px] items-center justify-between border-b border-[#1a1a1a] bg-black px-4 md:px-10" data-id="element-1475">
        <div className="font-heading text-[13px] font-black tracking-[3px] text-white uppercase" data-id="element-1476">
          AI <span className="text-[#F5C842]" data-id="element-1477">WEB CLOSER</span>
        </div>
        <div className="flex gap-1 overflow-x-auto" data-id="element-1478">
          <a href="/modulo-0" className="rounded bg-[#F5C842] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-black transition-all" data-id="element-1479">
            Módulo 0
          </a>
          <a href="/modulo-1" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1480">
            Módulo 1
          </a>
          <a href="/modulo-2" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1481">
            Módulo 2
          </a>
          <a href="/modulo-3" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1482">
            Módulo 3
          </a>
          <a href="/modulo-4" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#555] transition-all hover:bg-[#1a1a1a] hover:text-white" data-id="element-1483">
            Módulo 4
          </a>
          <a href="/calculadora" className="rounded px-3.5 py-1.5 text-[11px] font-bold tracking-[0.5px] text-[#F5C842] transition-all hover:bg-[#1a1a1a] border border-[#F5C842]/30" data-id="element-1484">
            Calculadora
          </a>
        </div>
      </nav>

      {/* HERO */}
      <div className="border-b-[3px] border-[#F5C842] bg-gradient-to-br from-black to-[#0d0d0d] px-6 py-10 md:px-20 md:py-[60px] pb-[50px]" data-id="element-1485">
        <div className="mb-5 flex flex-wrap items-center gap-2.5" data-id="element-1486">
          <div className="rounded-sm bg-[#4caf50] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1487">
            Empieza Aquí
          </div>
          <div className="rounded-sm bg-[#F5C842] px-3.5 py-1 font-heading text-[9px] font-black tracking-[3px] text-black uppercase" data-id="element-1488">
            Módulo 0
          </div>
          <div className="text-[11px] tracking-[2px] text-[#444] uppercase" data-id="element-1489">
            ⏱ 30 minutos · Configuración del Sistema
          </div>
        </div>
        <div className="mb-4 font-heading text-4xl md:text-[48px] font-black leading-[1.05] text-white" data-id="element-1490">
          Herramientas
          <br data-id="element-1491" />
          <span className="text-[#F5C842]" data-id="element-1492">Necesarias</span> para
          <br data-id="element-1493" />
          tu Sistema
        </div>
        <div className="mb-8 max-w-[640px] text-[15px] leading-[1.7] text-[#888]" data-id="element-1494">
          Antes de conseguir tu primer cliente, necesitas tener las herramientas
          correctas configuradas. En este módulo vas a instalar las 3 piezas
          fundamentales de tu sistema: MagicPatterns, los Custom AI Brains de
          Heylloyd y tu dominio en Namecheap.
        </div>
        <div className="flex flex-col md:flex-row gap-4 md:gap-6" data-id="element-1495">
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1496">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1497"></div>
            Configuración de MagicPatterns
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1498">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1499"></div>
            Cuenta de Heylloyd + Custom AI Brains
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1500">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1501"></div>2 AI
            Brains listos para descargar
          </div>
          <div className="flex items-center gap-2 text-[12px] text-[#555]" data-id="element-1502">
            <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1503"></div>
            Dominio en Namecheap
          </div>
        </div>
      </div>

      {/* MAIN */}
      <div className="mx-auto max-w-[1100px] px-4 py-10 md:px-10 md:py-[50px]" data-id="element-1504">
        {/* INFO BOX */}
        <div className="mb-6 rounded-r-lg border border-[#1a2a3a] border-l-[4px] border-l-[#4a9eff] bg-[#0a0f1a] px-[22px] py-[18px] text-[13px] leading-[1.75] text-[#aac4e8]" data-id="element-1505">
          <strong className="text-white" data-id="element-1506">¿Por qué este módulo existe?</strong>{' '}
          La mayoría de los cursos te lanzan al contenido sin asegurarse de que
          tienes las herramientas listas. Nosotros hacemos lo contrario.
          Completa este módulo primero y los siguientes van a fluir sin
          fricción.
        </div>

        {/* ==================== VIDEO 1 — MAGICPATTERNS ==================== */}
        <div className="mb-10" data-id="element-1507">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1508">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1509"></span>
            Video 1 de 3
          </div>
          <div className="mb-3.5 inline-flex items-center gap-2 rounded border border-[#2a2a2a] bg-[#1a1a1a] px-3.5 py-1.5" data-id="element-1510">
            <span className="font-heading text-[10px] font-black tracking-[2px] text-[#F5C842] uppercase" data-id="element-1511">
              🛠 Herramienta #1 — MagicPatterns
            </span>
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-1512">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-1513">
              <iframe src="https://player.vimeo.com/video/1179704772?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSER Video 0.0" data-id="element-1514" />
            </div>
          </div>
        </div>

        {/* MAGICPATTERNS CTA BUTTON — right after video */}
        <div className="mt-4 mb-10" data-id="element-1515">
          <a href="https://www.magicpatterns.com/" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-1516">
            <span className="text-[20px]" data-id="element-1517">🔗</span>
            Abrir MagicPatterns — Crear tu Cuenta
            <span className="text-[18px] font-black" data-id="element-1518">→</span>
          </a>
        </div>

        {/* MAGICPATTERNS INFO */}
        <div className="mb-10 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-1519">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1520">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1521">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1522"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1523">
                ¿Qué es MagicPatterns?
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1524">
              MagicPatterns es la herramienta de IA que convierte tus ideas en{' '}
              <strong className="text-white" data-id="element-1525">
                sitios web completos y profesionales
              </strong>{' '}
              en minutos. Sin código, sin diseñadores, sin experiencia técnica.
              <br data-id="element-1526" />
              <br data-id="element-1527" />
              Es el motor que construye los sitios web que vas a vender a tus
              clientes locales.{' '}
              <strong className="text-white" data-id="element-1528">Esta es tu arma principal.</strong>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1529">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1530">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1531"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1532">
                Lo que harás en el video
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1533">
              <ul className="flex flex-col" data-id="element-1534">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1535">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1536">
                    →
                  </span>
                  Crear tu cuenta gratuita en MagicPatterns
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1537">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1538">
                    →
                  </span>
                  Explorar el dashboard y las funciones principales
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1539">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1540">
                    →
                  </span>
                  Generar tu primer sitio web de práctica
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1541">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1542">
                    →
                  </span>
                  Entender cómo personalizar y exportar
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-1543">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1544">
                    →
                  </span>
                  Conectar MagicPatterns con tu flujo de trabajo
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* DIVIDER 1-2 */}
        <div className="relative mb-10 border-t border-[#1e1e1e]" data-id="element-1545">
          <div className="absolute left-1/2 top-[-10px] -translate-x-1/2 bg-[#0a0a0a] px-4" data-id="element-1546">
            <span className="text-[9px] font-bold tracking-[3px] text-[#333] uppercase" data-id="element-1547">
              Video 2 de 3
            </span>
          </div>
        </div>

        {/* ==================== VIDEO 2 — HEYLLOYD ==================== */}
        <div className="mb-10" data-id="element-1548">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1549">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1550"></span>
            Video 2 de 3
          </div>
          <div className="mb-3.5 inline-flex items-center gap-2 rounded border border-[#2a2a2a] bg-[#1a1a1a] px-3.5 py-1.5" data-id="element-1551">
            <span className="font-heading text-[10px] font-black tracking-[2px] text-[#F5C842] uppercase" data-id="element-1552">
              🧠 Herramienta #2 — Heylloyd + Custom AI Brains
            </span>
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-1553">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-1554">
              <iframe src="https://player.vimeo.com/video/1179706172?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSER Video 0.3 heylloyd" data-id="element-1555" />
            </div>
          </div>
        </div>

        {/* HEYLLOYD CTA BUTTONS — right after video */}
        <div className="mt-4 mb-10 flex flex-col gap-3" data-id="element-1556">
          <a href="https://heylloyd.io/" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-1557">
            <span className="text-[20px]" data-id="element-1558">🧠</span>
            Abrir Heylloyd.io — Crear tu Cuenta
            <span className="text-[18px] font-black" data-id="element-1559">→</span>
          </a>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-1560">
            <a href="https://app.heylloyd.io/share/lloyd/d98723a5-a08" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2.5 rounded-lg border-2 border-[#F5C842] bg-[#111] px-5 py-4 font-heading text-[12px] font-black tracking-[1px] text-[#F5C842] uppercase no-underline transition-opacity hover:opacity-85 text-center" data-id="element-1561">
              <span className="text-[16px]" data-id="element-1562">🧠</span>
              <span data-id="element-1563">
                Descargar AI Brain #1
                <br data-id="element-1564" />
                <span className="text-[10px] font-bold text-white" data-id="element-1565">
                  Ai Website Arbitrage
                </span>
              </span>
              <span className="text-[14px]" data-id="element-1566">↓</span>
            </a>
            <a href="https://app.heylloyd.io/share/lloyd/6f60b0db-b8a" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2.5 rounded-lg border-2 border-[#F5C842] bg-[#111] px-5 py-4 font-heading text-[12px] font-black tracking-[1px] text-[#F5C842] uppercase no-underline transition-opacity hover:opacity-85 text-center" data-id="element-1567">
              <span className="text-[16px]" data-id="element-1568">🧠</span>
              <span data-id="element-1569">
                Descargar AI Brain #2
                <br data-id="element-1570" />
                <span className="text-[10px] font-bold text-white" data-id="element-1571">
                  Sales Letter Weapon
                </span>
              </span>
              <span className="text-[14px]" data-id="element-1572">↓</span>
            </a>
          </div>
        </div>

        {/* HEYLLOYD INFO */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-1573">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1574">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1575">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1576"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1577">
                ¿Qué es Heylloyd?
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1578">
              Heylloyd es la IA que actúa como tu{' '}
              <strong className="text-white" data-id="element-1579">cerebro estratégico</strong>. No es
              un chatbot genérico — está entrenado con estrategias específicas
              para conseguir clientes locales, crear propuestas y cerrar ventas.
              <br data-id="element-1580" />
              <br data-id="element-1581" />
              Los <strong className="text-white" data-id="element-1582">Custom AI Brains</strong> son
              versiones especializadas de Heylloyd, pre-programadas con el
              conocimiento exacto que necesitas para este sistema.
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1583">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1584">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1585"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1586">
                Lo que harás en el video
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1587">
              <ul className="flex flex-col" data-id="element-1588">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1589">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1590">
                    →
                  </span>
                  Crear tu cuenta en Heylloyd
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1591">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1592">
                    →
                  </span>
                  Entender qué son los Custom AI Brains
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1593">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1594">
                    →
                  </span>
                  Descargar e instalar los 2 AI Brains del sistema
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1595">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1596">
                    →
                  </span>
                  Hacer tu primera prueba con cada Brain
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-1597">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1598">
                    →
                  </span>
                  Integrar Heylloyd en tu flujo de trabajo diario
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* DIVIDER 2-3 */}
        <div className="relative mb-10 border-t border-[#1e1e1e]" data-id="element-1599">
          <div className="absolute left-1/2 top-[-10px] -translate-x-1/2 bg-[#0a0a0a] px-4" data-id="element-1600">
            <span className="text-[9px] font-bold tracking-[3px] text-[#333] uppercase" data-id="element-1601">
              Video 3 de 3
            </span>
          </div>
        </div>

        {/* ==================== VIDEO 3 — NAMECHEAP ==================== */}
        <div className="mb-10" data-id="element-1602">
          <div className="mb-3 flex items-center gap-2 font-heading text-[9px] font-bold tracking-[3px] text-[#F5C842] uppercase" data-id="element-1603">
            <span className="inline-block h-[2px] w-5 bg-[#F5C842]" data-id="element-1604"></span>
            Video 3 de 3
          </div>
          <div className="mb-3.5 inline-flex items-center gap-2 rounded border border-[#2a2a2a] bg-[#1a1a1a] px-3.5 py-1.5" data-id="element-1605">
            <span className="font-heading text-[10px] font-black tracking-[2px] text-[#F5C842] uppercase" data-id="element-1606">
              🌐 Herramienta #3 — Namecheap
            </span>
          </div>
          <div className="overflow-hidden rounded-[10px] border-2 border-[#1e1e1e]" data-id="element-1607">
            <div style={{
            padding: '56.25% 0 0 0',
            position: 'relative'
          }} data-id="element-1608">
              <iframe src="https://player.vimeo.com/video/1179701343?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" allowFullScreen referrerPolicy="strict-origin-when-cross-origin" style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%'
            }} title="AI WEB CLOSER Video 0.1" data-id="element-1609" />
            </div>
          </div>
        </div>

        {/* NAMECHEAP CTA BUTTON — right after video */}
        <div className="mt-4 mb-10" data-id="element-1610">
          <a href="https://www.namecheap.com/" target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 w-full rounded-lg border-2 border-[#F5C842] bg-[#F5C842] px-8 py-[18px] font-heading text-[14px] font-black tracking-[1.5px] text-black uppercase no-underline transition-opacity hover:opacity-85" style={{
          boxShadow: '0 4px 20px rgba(245,200,66,0.25)'
        }} data-id="element-1611">
            <span className="text-[20px]" data-id="element-1612">🌐</span>
            Abrir Namecheap — Registrar tu Dominio
            <span className="text-[18px] font-black" data-id="element-1613">→</span>
          </a>
        </div>

        {/* NAMECHEAP INFO */}
        <div className="mb-8 grid grid-cols-1 gap-5 md:grid-cols-2" data-id="element-1614">
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1615">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1616">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1617"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1618">
                ¿Qué es Namecheap?
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1619">
              Namecheap es el registrador de dominios donde vas a comprar el
              dominio de tus clientes. Un dominio profesional le da{' '}
              <strong className="text-white" data-id="element-1620">credibilidad inmediata</strong> al
              sitio web que entregas y justifica tu precio de $350.
              <br data-id="element-1621" />
              <br data-id="element-1622" />
              Es rápido, económico y fácil de usar.{' '}
              <strong className="text-white" data-id="element-1623">
                Un dominio cuesta menos de $15 al año.
              </strong>
            </div>
          </div>
          <div className="overflow-hidden rounded-lg border border-[#1e1e1e] bg-[#111]" data-id="element-1624">
            <div className="flex items-center gap-2 border-b border-[#1e1e1e] bg-[#161616] px-[18px] py-3" data-id="element-1625">
              <div className="h-1.5 w-1.5 rounded-full bg-[#F5C842]" data-id="element-1626"></div>
              <div className="font-heading text-[9px] font-bold tracking-[2px] text-[#F5C842] uppercase" data-id="element-1627">
                Lo que harás en el video
              </div>
            </div>
            <div className="px-[18px] py-[18px] text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1628">
              <ul className="flex flex-col" data-id="element-1629">
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1630">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1631">
                    →
                  </span>
                  Crear tu cuenta en Namecheap
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1632">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1633">
                    →
                  </span>
                  Buscar y registrar un dominio para tu cliente
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1634">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1635">
                    →
                  </span>
                  Entender cómo funciona el DNS y el hosting
                </li>
                <li className="flex items-start gap-2 border-b border-[#1a1a1a] py-1" data-id="element-1636">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1637">
                    →
                  </span>
                  Conectar el dominio con el sitio web del cliente
                </li>
                <li className="flex items-start gap-2 py-1" data-id="element-1638">
                  <span className="mt-[1px] shrink-0 font-bold text-[#F5C842]" data-id="element-1639">
                    →
                  </span>
                  Gestionar múltiples dominios desde un solo panel
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* AI BRAINS DOWNLOAD SECTION */}
        <div className="mb-10 overflow-hidden rounded-[10px] border border-[#1e1e1e] bg-[#0d0d0d]" data-id="element-1640">
          <div className="flex items-center gap-3.5 border-b-[2px] border-[#F5C842] bg-gradient-to-r from-[#1a1400] to-[#0d0d0d] px-7 py-5" data-id="element-1641">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-[#F5C842] text-[20px]" data-id="element-1642">
              🧠
            </div>
            <div data-id="element-1643">
              <h3 className="mb-1 font-heading text-[16px] font-black text-white" data-id="element-1644">
                Descarga tus Custom AI Brains
              </h3>
              <p className="text-[12px] text-[#888]" data-id="element-1645">
                Los 2 cerebros de IA pre-entrenados para tu sistema AI Web
                Closer
              </p>
            </div>
          </div>
          <div className="px-7 py-6" data-id="element-1646">
            <div className="mb-6 text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1647">
              Estos no son prompts genéricos. Son{' '}
              <strong className="text-[#F5C842]" data-id="element-1648">Custom AI Brains</strong> —
              versiones especializadas de Heylloyd entrenadas específicamente
              para las dos tareas más críticas de tu negocio. Descárgalos
              después de ver el video y tenlos listos antes de pasar al Módulo
              1.
            </div>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2" data-id="element-1649">
              {/* BRAIN 1 */}
              <div className="flex flex-col gap-3.5 rounded-lg border border-[#2a2a2a] bg-[#111] p-5 transition-colors hover:border-[#F5C842]" data-id="element-1650">
                <div className="flex items-start gap-3" data-id="element-1651">
                  <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1652">
                    01
                  </div>
                  <div data-id="element-1653">
                    <h4 className="mb-1 font-heading text-[13px] font-black text-white" data-id="element-1654">
                      Ai Website Arbitrage
                    </h4>
                    <p className="text-[11px] leading-[1.5] text-[#666]" data-id="element-1655">
                      El cerebro especializado en identificar oportunidades de
                      mercado, analizar negocios locales sin sitio web y generar
                      estrategias de prospección. Tu arma para encontrar
                      clientes.
                    </p>
                  </div>
                </div>
                <a href="https://app.heylloyd.io/share/lloyd/d98723a5-a08" target="_blank" rel="noreferrer" className="mt-auto flex items-center justify-center gap-2 rounded-md bg-[#F5C842] px-4 py-2.5 font-heading text-[11px] font-black tracking-[1px] text-black uppercase no-underline transition-opacity hover:opacity-85" data-id="element-1656">
                  <span className="text-[14px]" data-id="element-1657">⬇</span>
                  Descargar AI Brain #1 — Website Arbitrage
                </a>
              </div>

              {/* BRAIN 2 */}
              <div className="flex flex-col gap-3.5 rounded-lg border border-[#2a2a2a] bg-[#111] p-5 transition-colors hover:border-[#F5C842]" data-id="element-1658">
                <div className="flex items-start gap-3" data-id="element-1659">
                  <div className="flex h-8 w-8 min-w-[32px] items-center justify-center rounded-md bg-[#F5C842] font-heading text-[14px] font-black text-black" data-id="element-1660">
                    02
                  </div>
                  <div data-id="element-1661">
                    <h4 className="mb-1 font-heading text-[13px] font-black text-white" data-id="element-1662">
                      Sales Letter Weapon
                    </h4>
                    <p className="text-[11px] leading-[1.5] text-[#666]" data-id="element-1663">
                      El cerebro especializado en crear propuestas
                      irresistibles, sales pages de alta conversión y mensajes
                      de cierre. Tu arma para convertir prospectos en clientes
                      que pagan.
                    </p>
                  </div>
                </div>
                <a href="https://app.heylloyd.io/share/lloyd/6f60b0db-b8a" target="_blank" rel="noreferrer" className="mt-auto flex items-center justify-center gap-2 rounded-md bg-[#F5C842] px-4 py-2.5 font-heading text-[11px] font-black tracking-[1px] text-black uppercase no-underline transition-opacity hover:opacity-85" data-id="element-1664">
                  <span className="text-[14px]" data-id="element-1665">⬇</span>
                  Descargar AI Brain #2 — Sales Letter Weapon
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* TASK BOX */}
        <div className="mb-8 rounded-r-lg border border-[#1a3a1a] border-l-[4px] border-l-[#4caf50] bg-[#0a150a] px-[26px] py-[22px]" data-id="element-1666">
          <div className="mb-2.5 font-heading text-[9px] font-bold tracking-[2px] text-[#4caf50] uppercase" data-id="element-1667">
            ✅ Tarea de Acción — Módulo 0
          </div>
          <div className="text-[13px] leading-[1.75] text-[#bbb]" data-id="element-1668">
            <strong className="text-white" data-id="element-1669">
              Antes de pasar al Módulo 1, completa estos 5 pasos:
            </strong>
            <div className="mt-3 flex flex-col gap-2" data-id="element-1670">
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1671">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1672">
                  1
                </div>
                <div data-id="element-1673">
                  Ve el Video 1 y crea tu cuenta en{' '}
                  <strong className="text-white" data-id="element-1674">MagicPatterns</strong>. Genera
                  un sitio web de prueba con cualquier prompt para
                  familiarizarte con la herramienta.
                </div>
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1675">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1676">
                  2
                </div>
                <div data-id="element-1677">
                  Ve el Video 2 y crea tu cuenta en{' '}
                  <strong className="text-white" data-id="element-1678">Heylloyd</strong>.
                </div>
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1679">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1680">
                  3
                </div>
                <div data-id="element-1681">
                  Descarga e instala los{' '}
                  <strong className="text-white" data-id="element-1682">2 Custom AI Brains</strong>{' '}
                  usando los botones de arriba. Ábrelos en Heylloyd y haz una
                  pregunta de prueba a cada uno.
                </div>
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1683">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1684">
                  4
                </div>
                <div data-id="element-1685">
                  Ve el Video 3 y crea tu cuenta en{' '}
                  <strong className="text-white" data-id="element-1686">Namecheap</strong>.
                  Familiarízate con el panel de dominios — lo vas a usar desde
                  el Módulo 1.
                </div>
              </div>
              <div className="flex items-start gap-2.5 text-[13px] text-[#bbb]" data-id="element-1687">
                <div className="flex h-[22px] w-[22px] min-w-[22px] items-center justify-center rounded-full bg-[#4caf50] text-[10px] font-black text-black" data-id="element-1688">
                  5
                </div>
                <div data-id="element-1689">
                  Cuando tengas las 3 herramientas activas y los 2 AI Brains
                  instalados,{' '}
                  <strong className="text-white" data-id="element-1690">pasa al Módulo 1</strong>.
                  Estás listo.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* FOOTER NAV */}
      <div className="mt-5 flex items-center justify-between border-t border-[#1a1a1a] bg-black px-4 py-6 md:px-10" data-id="element-1691">
        <div className="font-heading text-[11px] font-black tracking-[3px] text-[#333] uppercase" data-id="element-1692">
          AI <span className="text-[#F5C842]" data-id="element-1693">WEB CLOSER</span>
        </div>
        <a href="/modulo-1" className="flex items-center gap-2 rounded bg-[#F5C842] px-7 py-3 font-heading text-[12px] font-black tracking-[1px] text-black uppercase transition-opacity hover:opacity-85" data-id="element-1694">
          Módulo 1 — El Mercado de Oro →
        </a>
      </div>
    </div>;
}